<template>


    <nav class="cf-menutop" ref="menuroot">
        <div class="cf-menu-inner">

            <!-- Bascule mobile -->
            <button @click="toggleNavbar" type="button" class="cf-menu-burger" :aria-expanded="isNavbarOpen.toString()">
                <span class="sr-only">Ouvrir le menu</span>
                <i class="ri-menu-line"></i>
            </button>

            <div :class="{ 'hidden': !isNavbarOpen, 'block': isNavbarOpen }" class="cf-menu-collapse" id="navbar-dropdown">
                <ul class="cf-menu-list">

                    <!-- Magasin -->
                    <li v-permission="'definitions.magasins'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindexmagasin(); openMenu = null; isNavbarOpen = false">
                            <i class="ri-store-2-line cf-menu-icon"></i> Magasin
                        </button>
                    </li>

                    <!-- Catalogue -->
                    <li v-permission="'definitions.catalogue'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindex('cat'); openMenu = null; isNavbarOpen = false">
                            <i class="ri-book-open-line cf-menu-icon"></i> Catalogue
                        </button>
                    </li>

                    <!-- Unité -->
                    <li v-permission="'definitions.unite'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindex('unite'); openMenu = null; isNavbarOpen = false">
                            <i class="ri-ruler-line cf-menu-icon"></i> Unité
                        </button>
                    </li>

                    <!-- Dépréciation -->
                    <li v-permission="'definitions.depreciation'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindex('depreciation'); openMenu = null; isNavbarOpen = false">
                            <i class="ri-percent-line cf-menu-icon"></i> Dépréciation
                        </button>
                    </li>

                    <!-- Mode de réglement -->
                    <li v-permission="'definitions.modereglement'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindex('mdreglement'); openMenu = null; isNavbarOpen = false">
                            <i class="ri-bank-card-line cf-menu-icon"></i> Mode réglement
                        </button>
                    </li>

                    <!-- Condiction de réglement -->
                    <li v-permission="'definitions.condictionreglement'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindex('condiction_reglement'); openMenu = null; isNavbarOpen = false">
                            <i class="ri-file-list-3-line cf-menu-icon"></i> Condiction réglement
                        </button>
                    </li>

                    <!-- Liste des charges -->
                    <li v-permission="'definitions.listedescharges'">
                        <button type="button" class="cf-menu-btn" @click="btnmodalindex('charge'); openMenu = null; isNavbarOpen = false">
                            <i class="ri-bill-line cf-menu-icon"></i> Charges
                        </button>
                    </li>

                    <!-- Dépôt de boisson -->
                    <li v-permission="'definitions.depotboisson'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'depot' }" @click="toggleMenu('depot')">
                            <i class="ri-goblet-line cf-menu-icon"></i> Dépôt boisson
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'depot' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'depot'" class="cf-menu-pop">
                                <button type="button" class="cf-menu-item" @click="btnmodalindex('emballage'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-inbox-line"></i> Emballages
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Restaurant -->
                    <li v-permission="'definitions.restaurant'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'resto' }" @click="toggleMenu('resto')">
                            <i class="ri-restaurant-line cf-menu-icon"></i> Restaurant
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'resto' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'resto'" class="cf-menu-pop">
                                <button type="button" class="cf-menu-item" @click="btnmodalindex('accompagnement'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-restaurant-2-line"></i> Accompagnement des plats
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalindex('table'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-table-line"></i> Table
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalclt('col'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-user-star-line"></i> Serveur / Serveuse
                                </button>
                            </div>
                        </transition>
                    </li>

                    <!-- Paramètres d'indications -->
                    <li v-permission="'definitions.parametreindication'" class="cf-menu-dd">
                        <button type="button" class="cf-menu-btn" :class="{ 'cf-menu-btn--on': openMenu === 'param' }" @click="toggleMenu('param')">
                            <i class="ri-settings-3-line cf-menu-icon"></i> Paramètres indications
                            <i class="ri-arrow-down-s-line cf-menu-caret" :class="{ 'cf-menu-caret--on': openMenu === 'param' }"></i>
                        </button>
                        <transition name="cf-menu-fade">
                            <div v-show="openMenu === 'param'" class="cf-menu-pop">
                                <button type="button" class="cf-menu-item" @click="btnmodalindex('paramstock'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-archive-line"></i> Stock
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalindex('paramcom'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-shopping-cart-2-line"></i> Commerciale
                                </button>
                                <button type="button" class="cf-menu-item" @click="btnmodalindex('paramcaisse'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-computer-line"></i> Caisse
                                </button>
                                <!--button type="button" class="cf-menu-item" @click="btnmodalindex('paramcaissedep'); openMenu = null; isNavbarOpen = false">
                                    <i class="ri-wallet-3-line"></i> Dépenses
                                </button-->
                            </div>
                        </transition>
                    </li>

                </ul>
            </div>
        </div>
    </nav>


    <modalindexmagasin ref="modalindexmagasin"></modalindexmagasin>
    <modalindex ref="modalindex"></modalindex>
    <modalfrsclt ref="modalfrsclt"></modalfrsclt>
</template>


<script>

    import modalindexmagasin from "@/components/views/pages/definition/magasin/index";
    import modalindex from "@/components/views/pages/definition/fichiersdebase/index";
    import modalfrsclt from "@/components/views/pages/gestioncommerciale/frscltcolb/index";



    export default {
        /* eslint-disable */
        name: "mymenu",
        data() {
            return {
                isNavbarOpen: false,
                isDropdownOpen: true,
                openMenu: null
            };
        },
        components: {
            modalindex,
            modalindexmagasin,
            modalfrsclt,
        },
            methods: {



                btnmodalclt(value){

                    let titlemodal


                    if (value==='col'){
                        titlemodal="Liste des serveurs"
                    }


                    this.$refs.modalfrsclt.show(titlemodal,value,"Serveur");
                },


                btnmodalindex(value){

                    let titlemodal

                    if (value==='centre_de_consommation'){
                        //="Ajouter"
                        titlemodal="Liste des centres de consommations"
                    }


                    if (value==='paramstock'){
                        //="Ajouter"
                        titlemodal="Liste des paramétres d'indication pour la gestion de stock"
                    }

                    if (value==='paramcaisse'){
                        //="Ajouter"
                        titlemodal="Liste des paramétres d'indication pour la gestion des caisses"
                    }

                    if (value==='paramcaissedep'){
                        //="Ajouter"
                        titlemodal="Liste des paramétres d'indication de dépense pour la gestion des caisses"
                    }

                    if (value==='paramcom'){
                        //="Ajouter"
                        titlemodal="Liste des paramétres d'indication"
                    }

                    if (value==='table'){
                        //="Ajouter"
                        titlemodal="Liste des tables"
                    }

                    if (value==='accompagnement'){
                        //="Ajouter"
                        titlemodal="Liste des accompagnements de plat"
                    }

                    if (value==='depreciation'){
                        //="Ajouter"
                        titlemodal="Liste des types de dépréciation"
                    }

                    if (value==='mdreglement'){
                        //="Ajouter"
                        titlemodal="Liste des mode de réglements"
                    }

                    if (value==='cat'){
                        //="Ajouter"
                        titlemodal="Liste des catalogues"
                    }
                    if (value==='unite'){
                        //="Ajouter"
                        titlemodal="Liste des unites"
                    }


                    if (value==='condiction_reglement'){
                        //="Ajouter"
                        titlemodal="Liste des condictions de réglement"
                    }



                    if (value==='emballage'){
                        //="Ajouter"
                        titlemodal="Liste des emballages"
                    }



                    if (value==='charge'){
                        //="Ajouter"
                        titlemodal="Liste des charges"
                    }

                    this.$refs.modalindex.show(titlemodal,value);
                },

                btnmodalindexmagasin(){

                    let titlemodal


                        titlemodal="Liste des magasins"

                    this.$refs.modalindexmagasin.show(titlemodal);
                },



            toggleNavbar() {
                this.isNavbarOpen = !this.isNavbarOpen;
            },
            toggleDropdown() {
                console.log("1122")

                this.isDropdownOpen = !this.isDropdownOpen;

                //console.log("1122 this.isDropdownOpen ",this.isDropdownOpen)
            },

            // Plumbing menus manuels (remplace Preline hs-dropdown)
            toggleMenu(name) {
                this.openMenu = this.openMenu === name ? null : name;
            },
            handleGlobalClick(e) {
                const root = this.$refs.menuroot;
                if (root && !root.contains(e.target)) {
                    this.openMenu = null;
                }
            }
        },

        mounted() {
            document.addEventListener('click', this.handleGlobalClick);
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleGlobalClick);
        }
    };
</script>

<style scoped>
    /* Charte cf-/ds- : barre de menu du module Définition (light-only) */
    .cf-menutop {
        margin-top: 4% !important;
        background: #fff;
        border: 1px solid rgb(var(--default-border));
        border-radius: var(--cf-radius);
        box-shadow: var(--cf-shadow-sm);
    }
    @media screen and (max-width: 800px) { .cf-menutop { margin-top: 12.5% !important; } }

    .cf-menu-inner {
        display: flex; flex-wrap: wrap; align-items: center; gap: 0.5rem 1rem;
        padding: 0.6rem 1rem; max-width: 1280px; margin: 0 auto;
    }
    .cf-menutop__brand {
        display: inline-flex; align-items: center; gap: 0.5rem;
        font-weight: 700; font-size: 0.95rem; letter-spacing: -0.01em;
        color: rgb(var(--primary)); text-decoration: none;
    }
    .cf-menutop__brand i { font-size: 1.15rem; }

    .cf-menu-burger {
        margin-left: auto; height: 38px; width: 38px; border: 1px solid var(--cf-border);
        border-radius: var(--cf-radius-sm); background: #fff; color: var(--cf-muted);
        display: inline-flex; align-items: center; justify-content: center; font-size: 1.2rem; cursor: pointer;
    }
    .cf-menu-burger:hover { color: rgb(var(--primary)); border-color: rgb(var(--primary) / 0.35); }
    @media (min-width: 768px) { .cf-menu-burger { display: none; } }

    .cf-menu-collapse { width: 100%; }
    @media (min-width: 768px) { .cf-menu-collapse { display: block !important; width: auto; margin-left: auto; } }

    .cf-menu-list {
        display: flex; flex-direction: column; gap: 0.2rem; list-style: none;
        margin: 0.6rem 0 0; padding: 0;
    }
    @media (min-width: 768px) {
        .cf-menu-list { flex-direction: row; align-items: center; justify-content: flex-end; gap: 0.4rem; margin: 0; }
    }

    .cf-menu-dd { position: relative; }

    .cf-menu-btn {
        display: inline-flex; align-items: center; gap: 0.35rem; width: 100%;
        padding: 0.5rem 0.75rem; border-radius: var(--cf-radius-sm);
        font-weight: 600; font-size: 0.85rem; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: color 0.18s ease, background-color 0.18s ease;
    }
    @media (min-width: 768px) { .cf-menu-btn { width: auto; } }
    .cf-menu-btn:hover { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.07); }
    .cf-menu-btn--on { color: rgb(var(--primary)); background: rgb(var(--primary) / 0.10); }
    .cf-menu-icon { color: rgb(var(--primary)); font-size: 1rem; }
    .cf-menu-caret { margin-left: auto; font-size: 0.9rem; color: var(--cf-faint); transition: transform 0.18s ease; }
    @media (min-width: 768px) { .cf-menu-caret { margin-left: 0.15rem; } }
    .cf-menu-caret--on { transform: rotate(180deg); color: rgb(var(--primary)); }

    .cf-menu-pop {
        display: flex; flex-direction: column; gap: 1px;
        margin: 0.15rem 0 0.35rem 0.75rem; padding: 0.35rem;
        border-left: 2px solid var(--cf-border);
    }
    @media (min-width: 768px) {
        .cf-menu-pop {
            position: absolute; top: calc(100% + 6px); right: 0; left: auto; z-index: 40;
            min-width: 260px; margin: 0; padding: 0.4rem;
            background: #fff; border: 1px solid var(--cf-border); border-left: 1px solid var(--cf-border);
            border-radius: var(--cf-radius); box-shadow: var(--cf-shadow-md);
        }
    }

    .cf-menu-item {
        display: flex; align-items: center; gap: 0.5rem; width: 100%;
        padding: 0.5rem 0.65rem; border-radius: var(--cf-radius-sm);
        font-size: 0.82rem; font-weight: 500; color: var(--cf-ink);
        background: transparent; border: 0; cursor: pointer; text-align: left;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .cf-menu-item i { color: var(--cf-muted); font-size: 1rem; flex-shrink: 0; }
    .cf-menu-item:hover { background: rgb(var(--primary) / 0.08); color: rgb(var(--primary)); }
    .cf-menu-item:hover i { color: rgb(var(--primary)); }
    .cf-menu-item--muted { color: var(--cf-faint); cursor: not-allowed; }
    .cf-menu-item--muted:hover { background: transparent; color: var(--cf-faint); }
    .cf-menu-item--muted:hover i { color: var(--cf-muted); }

    .cf-menu-fade-enter-active, .cf-menu-fade-leave-active { transition: opacity 0.15s ease, transform 0.15s ease; }
    .cf-menu-fade-enter-from, .cf-menu-fade-leave-to { opacity: 0; transform: translateY(-4px); }

    .sr-only {
        position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px;
        overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0;
    }

    button:focus { outline: 0 !important; }
</style>
